import React, { useContext } from "react";
import { ButtonRenderProps, ContentSection, Stack, LabeledText } from "sprint-common-web";

import { TvSeriesPageContext } from "../context/TvSeriesPageContext";
import { EditTvSeriesButton, EditTvSeriesButtonProps } from "./buttons/EditTvSeriesButton";

export const TvSeriesInfo: React.FunctionComponent = () => {
    const tvSeriesContext = useContext(TvSeriesPageContext);

    const editButtonProps: ButtonRenderProps<EditTvSeriesButtonProps> = {
        render: () => EditTvSeriesButton({ isLabeled: true })
    };

    return (
        <ContentSection isLoading={tvSeriesContext.isLoading} header="Info" buttons={[editButtonProps]}>
            <Stack horizontal={true} tokens={{ childrenGap: "100" }}>
                <LabeledText value={tvSeriesContext.tvSeries?.title ?? ""} label="Title" />
            </Stack>
        </ContentSection>
    );
};
